import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MigrateEmailContact } from './migrate_email_contact.types';

export const initialMigrateEmailContact: MigrateEmailContact = {
    newContactEmail: '',
    phone: 0,
    phoneError: false,
};

const migrateEmailContact = createSlice({
    name: 'migrate_email_contact',
    initialState: initialMigrateEmailContact,
    reducers: {
        setNewEmailContact: (state, action: PayloadAction<string>) => {
            state.newContactEmail = action.payload;
        },
        setPhone: (state, action: PayloadAction<number>) => {
            state.phone = action.payload;
        },
        setPhoneError: (state, action: PayloadAction<boolean>) => {
            state.phoneError = action.payload;
        },
    },
});

export const { setNewEmailContact, setPhone, setPhoneError } = migrateEmailContact.actions;

export const selectMigrateEmailContact = (state: { migrate_emaiL_contact: MigrateEmailContact }) => state.migrate_emaiL_contact;

export default migrateEmailContact.reducer;
